import { ReactNode } from "react";

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

const Container = ({ children, className }: ContainerProps) => {
  return (
    <div className={`container mx-auto pl-4 pr-4 pt-4 pb-4 ${className}`}>
      {children}
    </div>
  );
};

export default Container;
